import styled from '@emotion/styled'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import CollectImage from './CollectImage'

const copy = {
  overline: `Collect`,
  heading: `How you collect your customer data `,
  description: `Evaluating data collection involves looking at how complete, reliable, and standardized your customer data foundation is.`,
}

const Collect = () => (
  <SectionBase variant="2Col">
    <SectionCopy alignSelf="center">
      <CopyTextBase>
        <CopyText.Overline>{copy.overline}</CopyText.Overline>
        <CopyText.Heading tag="h2">{copy.heading}</CopyText.Heading>
        <CopyText.Description variant="pLarge" tag="p">
          {copy.description}
        </CopyText.Description>
      </CopyTextBase>
    </SectionCopy>
    <Section.Contents>
      <CollectImage />
    </Section.Contents>
  </SectionBase>
)

const SectionCopy = styled(Section.Copy)`
  max-width: 440px;
`

export default Collect
